
const getters = {
    getToken:(state) => state.token,
    getRole: (state) => state.role,
    getUserId: (state) => state.userId,
}
export default getters;
